angular.module('impactx.util').service('MinWidthService', [
    '$document',
    MinWidthService
]);

function MinWidthService($document) {

    function setSpecialMinWidthForDialog(scope, minWidth) {
        $document[0].body.style.minWidth = minWidth + "px";

        scope.$on('$destroy', function() {
            $document[0].body.style.minWidth = '';
        });
    }

    return {
        setSpecialMinWidthForDialog: setSpecialMinWidthForDialog
    };
}